import { render, staticRenderFns } from "./MandalikaGP.vue?vue&type=template&id=323becb0"
import script from "./MandalikaGP.vue?vue&type=script&lang=js"
export * from "./MandalikaGP.vue?vue&type=script&lang=js"
import style0 from "./MandalikaGP.vue?vue&type=style&index=0&id=323becb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports